import { jwtDecode } from 'jwt-decode';
import { axiosAuthClient as axios } from 'services/network/axiosClient';
import * as types from './types';
import { domains } from 'global';
import type { AppDispatch } from 'services/store/types';
import { logError } from 'utils/logs';

type ThunkActionCreator = (dispatch: AppDispatch) => Promise<void>;
type ThunkActionCreatorFactory = (auth: boolean) => ThunkActionCreator;

const handleTokenError = async (dispatch: AppDispatch, verify: ThunkActionCreatorFactory, auth: boolean) => {
  const params = new URLSearchParams(window.location.search);
  let refreshToken = params.get('refresh_token');
  if (!refreshToken) {
    refreshToken = window.localStorage.getItem('auth_refresh');
  }
  if (refreshToken) {
    const { data: dataRefresh } = await axios.post('/auth/refresh_token', { refresh_token: refreshToken });
    if (dataRefresh.status === 'OK') {
      window.sessionStorage.setItem('auth_token', dataRefresh.data.token);
      window.localStorage.setItem('auth_refresh', dataRefresh.data.refresh_token);
      dispatch(verify(auth));
    } else if (auth) {
      document.location.assign(`${domains.auth}?redirect=${window.location.href}`);
    }
  } else if (auth) {
    document.location.assign(`${domains.auth}?redirect=${window.location.href}`);
  }
};

function verifyToken(auth = true): ThunkActionCreator {
  return async (dispatch: AppDispatch) => {
    dispatch({ type: types.FETCH_ROLE_REQUEST, payload: undefined });
    try {
      const token = window.sessionStorage.getItem('auth_token');
      if (!token) {
        await handleTokenError(dispatch, verifyToken, auth);
      } else {
        try {
          const decoded = jwtDecode<JwtDecodedType>(token);
          decoded.iss = Number(decoded.iss);
          if (Date.now() <= decoded.exp * 1000) {
            window.sessionStorage.setItem('auth_id', decoded.iss.toString());
            dispatch({
              type: 'SET_AUTH_DATA',
              payload: {
                email: decoded.email,
                phone: decoded.phone,
                firstName: decoded.firstName,
                lastName: decoded.lastName,
              },
            });
            dispatch({
              type: types.FETCH_ROLE_SUCCEEDED,
              payload: decoded,
            });
          } else {
            await handleTokenError(dispatch, verifyToken, auth);
          }
        } catch {
          await handleTokenError(dispatch, verifyToken, auth);
        }
      }
    } catch (err) {
      logError(err as Error);
      dispatch({ type: types.FETCH_ROLE_FAILED, payload: err });
    }
  };
}

type JwtDecodedType = {
  exp: number,
  iat: number,
  iss: number | string,
  email: string,
  username: string,
  firstName: string,
  lastName: string,
  phone: string,
  roles: string[]
};

export function isUserAuthorized(usersRoles: string[], necessaryRoles: string[]) {
  return necessaryRoles.every((r: string) => usersRoles.includes(r));
}

export default verifyToken;
